import React from 'react';
import Icon from '../../Components/Icons/Icon';

export const KeyboardShortcut = ({ shortcut }) => {
    const isMac = () => {
        if (navigator.userAgentData) {
            return navigator.userAgentData.platform === 'macOS';
        }
        return /Mac|iPod|iPhone|iPad/.test(navigator.userAgent);
    };

    return (
        <span className="text-muted">
            ({isMac() ? shortcut.replace('Ctrl', '⌘') : shortcut})
        </span>
    );
};

const RedesignSearchField = ({ onOpen }) => {
    return (
        <div
            className="mb-4 flex items-center gap-3 px-3 py-2 cursor-pointer bg-white dark:bg-black border dark:border-none rounded-full w-full text-muted"
            onClick={onOpen}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onOpen();
                }
            }}
        >
            <Icon icon="MagnifyingGlass" size="1x" />
            <span className="font-medium">Search</span>
            <KeyboardShortcut shortcut="Ctrl+K" />
        </div>
    );
};

export default RedesignSearchField;
